(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function quickAdd(){
    if(document.querySelectorAll('.quick_add')) document.querySelectorAll('.quick_add').forEach((quick_add) => {
      quick_add.addEventListener('mouseenter',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        quick_add.closest('.snippet-product-grid').classList.add('view_sizes');
      });
    });
    if(document.querySelectorAll('.quick_view_button')) document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
      quickBtn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        let url = quickBtn.getAttribute('data-url');
        let modal = quickBtn.getAttribute('data-modal');
        fetch(url)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, 'text/html');
          const source = html.getElementById('section-quick-buy');
          document.body.classList.add('open-quick-buy');
          document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
          addToCart();
        })
        .catch((e) => {console.error(e);})
      })
    })
  }
  class ProductRecommendations extends HTMLElement {
    constructor(){
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        let slider;
        observer.unobserve(this);
        fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if(recommendations && recommendations.innerHTML.trim().length){
            this.innerHTML = recommendations.innerHTML;
          }
          if(html.querySelector('.grid__item')){
            this.classList.add('product-recommendations--loaded');
          }
          quickAdd();
          quickAddButton();
          document.querySelectorAll('.product-carousel').forEach(function(Element,index){
            if(!Element.classList.contains('is-initialized')){
              let productid = Element.dataset.id;
              let outer_carousel = Element.closest('.related-products');
              slider = new Splide(Element, {
                pagination: false,
                perPage: 4,
                perMove: 2,
                gap: 8,
                breakpoints: {
                  992: {
                    pagination: true,
                    perPage: 2,
                    perMove: 1,
                    gap: 5,
                  }
                },
                classes: {
                  arrows: 'splide__arrows splid-cus-arrows',
                  arrow : 'splide__arrow splid-cus-arrows',
                  prev  : 'splide__arrow--prev splid-cus-prev',
                  next  : 'splide__arrow--next splid-cus-next',
                }
              }).mount();
            }
            _swat.initializeActionButtons("body");
            
                    
            if(document.querySelectorAll('.related-tab li')) document.querySelectorAll('.related-tab li').forEach((tab) =>{
              let currentVal = tab.getAttribute('data-title');
              if(Element.closest('.carousel-rowouter').getAttribute('data-title') == currentVal){
                tab.addEventListener('click',function(e){
                  e.preventDefault();
                  e.stopImmediatePropagation();
                  let tabsWithIsOpen = document.querySelectorAll(".related-tab li.active-tab");
                  tabsWithIsOpen.forEach((tabWithIsOpen) => {
                    tabWithIsOpen.classList.remove("active-tab");
                  });
                  tab.classList.add("active-tab");
                  let currentCarousel = Element.closest('.carousel-rowouter').getAttribute('data-title');
                  if(currentVal == currentCarousel){
                    let carouselsWithIsOpen = document.querySelectorAll(".carousel-rowouter.active-carousel");
                    carouselsWithIsOpen.forEach((carouselWithIsOpen) => {
                      carouselWithIsOpen.classList.remove("active-carousel");
                    });
                    Element.closest('.carousel-rowouter').classList.add("active-carousel");
                  }
                  slider.refresh();
                   _swat.initializeActionButtons("body");
                });
              }
            });
          });
        })
        .catch(e => {console.error(e);});
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
